import type {
    PresencePersonRole,
    PresenceStackMember,
} from "@components/avatar/PresenceStack";

const person = ({
    name,
    role,
    detail,
    isLive = false,
    avatar = null,
}: {
    name: string;
    role: PresencePersonRole;
    detail: string;
    isLive?: boolean;
    avatar?: string | null;
}): PresenceStackMember => ({
    kind: "person",
    id: name,
    name,
    user: {
        name,
        email: null,
        avatar,
        iconColor: "var(--color-ocean-blue-200)",
    },
    role,
    detail,
    isLive,
});

const agent: PresenceStackMember = {
    kind: "agent",
    detail: "Working now",
    isLive: true,
};

export const presenceScenarios = [
    {
        id: "agent + viewers + assignee",
        members: [
            person({
                name: "Thea M.",
                role: "pinned",
                detail: "Assignee",
                avatar: "/images/thea.png",
            }),
            person({
                name: "Carla C.",
                role: "viewer",
                detail: "Last active 2h ago",
            }),
            agent,
            person({
                name: "Mo R.",
                role: "viewer",
                detail: "Viewing now",
                isLive: true,
            }),
        ],
    },
    {
        id: "unassigned",
        members: [
            { kind: "unassigned" },
            person({
                name: "Carla C.",
                role: "viewer",
                detail: "Viewing now",
                isLive: true,
            }),
        ],
    },
    {
        id: "work team overflow",
        members: [
            agent,
            person({ name: "Ana P.", role: "team", detail: "Preparer" }),
            person({
                name: "Ben K.",
                role: "team",
                detail: "Preparer, Reviewer",
            }),
            person({ name: "Cy L.", role: "team", detail: "Reviewer" }),
            person({
                name: "Mo R.",
                role: "viewer",
                detail: "Viewing now",
                isLive: true,
            }),
            person({
                name: "Carla C.",
                role: "viewer",
                detail: "Last active 2h ago",
            }),
        ],
    },
] as const satisfies ReadonlyArray<{
    id: string;
    members: readonly PresenceStackMember[];
}>;

export type PresenceScenarioId = (typeof presenceScenarios)[number]["id"];

export const presenceScenarioIds = presenceScenarios.map(
    (scenario) => scenario.id,
);
